import { render, staticRenderFns } from "./com-box1.vue?vue&type=template&id=36fbb86a&scoped=true&"
import script from "./com-box1.vue?vue&type=script&lang=js&"
export * from "./com-box1.vue?vue&type=script&lang=js&"
import style0 from "./com-box1.vue?vue&type=style&index=0&id=36fbb86a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fbb86a",
  null
  
)

export default component.exports